// =============================================================
// COMPONENT REGISTRY
// =============================================================
// How to add a new component with JavaScript:
//
// 1. Create src/js/components/{name}.js
// 2. Export a named function: export function initName() { ... }
// 3. Always guard against missing DOM element inside the function:
//      const el = document.querySelector('.selector');
//      if (!el) return;
// 4. Import and call it below (unconditionally if it guards itself,
//    or inside a page check if only needed on specific pages)
//
// Page detection uses WordPress body classes (added by helpers.php):
//   .home               → front page
//   .blog               → posts page
//   .single-product     → WooCommerce single product
//   .woocommerce-cart   → cart page
//   .woocommerce-account → account page
//   .post-type-archive-product → shop archive
//   .woocommerce-product-category → category archive
// =============================================================

import { initDropdown } from "./components/dropdown";
import { headerScroll } from "./components/header-scroll";
import { menuToggle, initMegaMenu } from "./components/menu";
import {
  heroSlider,
  relatedProductsSlider,
  TrustedBySlider,
  upSellProductsSlider,
  productGallerySlider,
} from "./components/sliders";
import { subMenu } from "./components/submenu";
import { TopOffersTabsSlider } from "./components/top-offers";
import { initBlogTabsScroll } from "./components/blog-tabs-scroll";
import { authNavigationHanlder } from "./woocommerce/auth";
import { ProductListFilters } from "./woocommerce/product-list-toolbar";
import { setupQuantityControls } from "./woocommerce/quantity-input";
import { initCopyToClipboard } from "./components/copyToClipboard";
import { initProductAttributesToggle } from "./components/product-attributes";

document.addEventListener("DOMContentLoaded", () => {
  const isHomePage = document.querySelector(".home");
  const isSingleProductPage = document.querySelector("body.single-product");
  const isCartPage = document.querySelector("body.woocommerce-cart");
  const isShopPage = document.querySelector("body.post-type-archive-product");
  const isCategoryPage = document.querySelector(
    "body.woocommerce-product-category"
  );
  const isWoocommerceAccount = document.querySelector(".woocommerce-account");
  menuToggle();
  initMegaMenu();
  initDropdown();
  subMenu();
  initBlogTabsScroll(); 
  initCopyToClipboard();
  if (isShopPage || isCategoryPage) {
    ProductListFilters();
  }
  if (isHomePage) {
    heroSlider();
    TrustedBySlider();
    TopOffersTabsSlider();
  }
  if (isSingleProductPage) {
    setupQuantityControls();
    upSellProductsSlider();
    relatedProductsSlider();
    productGallerySlider();
    initProductAttributesToggle();
  }
  if (isCartPage) {
    setupQuantityControls();
  }

  if (isWoocommerceAccount) {
    authNavigationHanlder();
  }

  function initScrollToSection() {
    const currentUrl = window.location.origin + window.location.pathname;
    const scrollLinks = document.querySelectorAll(
      'li.scrollToSection > a[href^="#"], li.scrollToSection > a[href*="/#"]'
    );

    scrollLinks.forEach((link) => {
      if (link.dataset.scrollBound) return;
      link.dataset.scrollBound = true;

      const linkUrl = new URL(link.href);

      if (linkUrl.origin + linkUrl.pathname === currentUrl) {
        link.addEventListener("click", (e) => {
          e.preventDefault();

          const targetId = linkUrl.hash.slice(1);
          const target = document.getElementById(targetId);

          if (target) {
            target.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        });
      }
    });
  }
  initScrollToSection();

  false;
});
